import { render, staticRenderFns } from "./Dg.vue?vue&type=template&id=316b84de&scoped=true&"
import script from "./Dg.vue?vue&type=script&lang=js&"
export * from "./Dg.vue?vue&type=script&lang=js&"
import style0 from "./Dg.vue?vue&type=style&index=0&id=316b84de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316b84de",
  null
  
)

export default component.exports